export const sectionTitleStyle = {
  fontSize: 40,
  fontWeight: 700,
  color: "#ffffff",
  padding: "0 21rem",
  lineHeight: "3.5rem",
};

export const sectionWrapperStyles = {
  background: "#2D1C6F",
  padding: "5rem 0",
};

export const graphCardWrapper = {
  background: "#35068C",
  padding: "2.5rem",
  borderRadius: "1rem",
  color: "#ffffff",
  height: "12.25rem",
};

export const smallCardsWrapper = {
  background: "#491F98",
  padding: "1rem",
  borderRadius: "1rem",
  backdropFilter: "blur(7.813rem)",
};

export const smallCardsWrapper2 = {
  background: "#491F98",
  padding: "1rem 2rem",
  textAlign: "center",
  borderRadius: "1rem",
  backdropFilter: "blur(7.813rem)",
};
